import { render, staticRenderFns } from "./FlightDetailForm.vue?vue&type=template&id=0462c71e&"
import script from "./FlightDetailForm.vue?vue&type=script&lang=js&"
export * from "./FlightDetailForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports